export const getRankDifferenceDisplay = (
  prediction,
  currentGameweek,
  rankDifference,
  isGreenArrow
) => {
  if (prediction === '-' || currentGameweek === 1) return '-';

  if (!rankDifference || typeof rankDifference !== 'number') return '';

  return `${isGreenArrow ? '+' : '-'}${Math.abs(
    rankDifference
  ).toLocaleString()}`;
};
